export default "__VITE_ASSET__uUvsKO8$__"